import { render, staticRenderFns } from "./TPAEmployeeDashboard.vue?vue&type=template&id=525fc9e8&scoped=true&"
import script from "./TPAEmployeeDashboard.vue?vue&type=script&lang=js&"
export * from "./TPAEmployeeDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TPAEmployeeDashboard.vue?vue&type=style&index=0&id=525fc9e8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525fc9e8",
  null
  
)

export default component.exports